import React from 'react';

const FilterButton = ({ 
  activeCount = 0, 
  hasActiveFilters = false, 
  onClick, 
  disabled = false,
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-3 py-2 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  };

  const baseClasses = `
    inline-flex items-center space-x-2 rounded-lg border font-medium
    transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500
    ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
    ${sizeClasses[size]}
  `;

  const stateClasses = hasActiveFilters
    ? 'bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100'
    : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${stateClasses} ${className}`}
      type="button"
      aria-label={`Filters${activeCount > 0 ? ` (${activeCount} active)` : ''}`}
    >
      {/* Filter Icon */}
      <svg 
        className="w-4 h-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707v4.172a1 1 0 01-.293.707L11 19.414V15a1 1 0 00-.293-.707L4.293 7.879A1 1 0 014 7.172V4z"
        />
      </svg>

      {/* Button Text */}
      <span>Filters</span>

      {/* Active Filter Count Badge */}
      {activeCount > 0 && (
        <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-blue-600 rounded-full min-w-[20px]">
          {activeCount > 99 ? '99+' : activeCount}
        </span>
      )}

      {/* Dropdown Arrow */}
      <svg 
        className="w-4 h-4 transition-transform duration-200" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M19 9l-7 7-7-7" 
        />
      </svg>
    </button>
  );
};

export default FilterButton;